module.exports = __webpack_public_path__ + "media/images/common/header_placeholder-3f78ac6c90e679eeeed30b7a20a66171.png";